// actions.js
import { UPDATE_PREF_FAILURE, UPDATE_PREF_REQUEST, UPDATE_PREF_SUCCESS } from '../auth/actionTypes';
import {
  FETCH_USERS_REQUEST,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAILURE,
  OPEN_EDIT_PAGE,
  OPEN_EDIT_PAGE_SUCCESS,
  DELETE_USERS_REQUEST,
  DELETE_USERS_FAILURE,
  DELETE_USERS_SUCCESS,
  FETCH_USER_REQUEST,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAILURE,
  UPDATE_USERS_REQUEST,
  UPDATE_USERS_SUCCESS,
  UPDATE_USERS_FAILURE,
  KPI_USERS_REQUEST,
  KPI_USERS_SUCCESS,
  KPI_USERS_FAILURE,
  UPDATE_PWD_REQUEST,
  UPDATE_PWD_SUCCESS,
  UPDATE_PWD_FAILURE,
  RESET_PASSWORD_FAILURE,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD,
  VALIDATE_PASSWORD_TOKEN_FAILURE,
  VALIDATE_PASSWORD_TOKEN_SUCCESS,
  VALIDATE_PASSWORD_TOKEN,
  REQUEST_PASSWORD_RESET_FAILURE,
  REQUEST_PASSWORD_RESET_SUCCESS,
  REQUEST_PASSWORD_RESET,
  REGISTER_USER_FAILURE,
  REGISTER_USER_SUCCESS,
  REGISTER_USER_REQUEST,
  ACTIVATE_ACCOUNT_REQUEST,
  ACTIVATE_ACCOUNT_SUCCESS,
  ACTIVATE_ACCOUNT_FAILURE,
  FETCH_CUSTOMERS_REQUEST,
  FETCH_CUSTOMERS_SUCCESS,
  FETCH_CUSTOMERS_FAILURE,
  KPI_CUSTOMERS_REQUEST,
  KPI_CUSTOMERS_SUCCESS,
  KPI_CUSTOMERS_FAILURE,
  VERIFY_USER_REQUEST,
  VERIFY_USER_SUCCESS,
  VERIFY_USER_FAILURE,
  BAN_USER_REQUEST,
  BAN_USER_SUCCESS,
  BAN_USER_FAILURE,
  CLEAR_USER_ERRORS,
  CLEAR_USER_SUCCESS,
  RESEND_ACTIVATION_EMAIL_REQUEST,
  RESEND_ACTIVATION_EMAIL_SUCCESS,
  RESEND_ACTIVATION_EMAIL_FAILURE,
  SEND_EMAIL_ADMIN_REQUEST,
  SEND_EMAIL_ADMIN_SUCCESS,
  SEND_EMAIL_ADMIN_FAILURE,
  ACTIVATE_USER_REQUEST,
  ACTIVATE_USER_SUCCESS,
  ACTIVATE_USER_FAILURE,
} from './actionTypes';

export const fetchUsersRequest = () => ({
  type: FETCH_USERS_REQUEST,
});

export const fetchUsersSuccess = (usersData) => ({
  type: FETCH_USERS_SUCCESS,
  payload: usersData,
});

export const fetchUsersFailure = (error) => ({
  type: FETCH_USERS_FAILURE,
  payload: error,
});

export const fetchCustomersRequest = () => ({
  type: FETCH_CUSTOMERS_REQUEST,
});

export const fetchCustomersSuccess = (usersData) => ({
  type: FETCH_CUSTOMERS_SUCCESS,
  payload: usersData,
});

export const fetchCustomersFailure = (error) => ({
  type: FETCH_CUSTOMERS_FAILURE,
  payload: error,
});

export const fetchUserRequest = (id) => ({
  type: FETCH_USER_REQUEST,
  payload: id
});

export const fetchUserSuccess = (user) => ({
  type: FETCH_USER_SUCCESS,
  payload: user,
});

export const fetchUserFailure = (error) => ({
  type: FETCH_USER_FAILURE,
  payload: error,
});

export const updateUserRequest = (user, navigate, isProfile = false) => ({
  type: UPDATE_USERS_REQUEST,
  payload: { user, navigate, isProfile }
});

export const updateUserSuccess = (user) => ({
  type: UPDATE_USERS_SUCCESS,
  payload: user,
});

export const updateUserFailure = (error) => ({
  type: UPDATE_USERS_FAILURE,
  payload: error,
});

export const updatePwdRequest = (user, navigate, isProfile = false) => ({
  type: UPDATE_PWD_REQUEST,
  payload: { user, navigate, isProfile }
});

export const updatePwdSuccess = () => ({
  type: UPDATE_PWD_SUCCESS,
});

export const updatePwdFailure = (error) => ({
  type: UPDATE_PWD_FAILURE,
  payload: error,
});

export const deleteUserRequest = (id) => ({
  type: DELETE_USERS_REQUEST,
  payload: id
});


export const deleteUserSuccess = (id) => ({
  type: DELETE_USERS_SUCCESS,
  payload: id,
});

export const deleteUserFailure = (error) => ({
  type: DELETE_USERS_FAILURE,
  payload: error,
});

export const openEditPage = (id, navigate) => ({
  type: OPEN_EDIT_PAGE,
  payload: { id, navigate }
});

export const openEditPageSuccess = () => ({
  type: OPEN_EDIT_PAGE_SUCCESS,
});

export const fetchUsersKpiRequest = () => ({
  type: KPI_USERS_REQUEST,
});

export const fetchUsersKpiSuccess = (usersKpi) => ({
  type: KPI_USERS_SUCCESS,
  payload: usersKpi,
});

export const fetchUsersKpiFailure = (error) => ({
  type: KPI_USERS_FAILURE,
  payload: error,
});

export const fetchCustomersKpiRequest = () => ({
  type: KPI_CUSTOMERS_REQUEST,
});

export const fetchCustomersKpiSuccess = (usersKpi) => ({
  type: KPI_CUSTOMERS_SUCCESS,
  payload: usersKpi,
});

export const fetchCustomersKpiFailure = (error) => ({
  type: KPI_CUSTOMERS_FAILURE,
  payload: error,
});

export const requestPasswordReset = (email) => ({
  type: REQUEST_PASSWORD_RESET,
  payload: email
});

export const requestPasswordResetSuccess = () => ({
  type: REQUEST_PASSWORD_RESET_SUCCESS
});

export const requestPasswordResetFailure = (error) => ({
  type: REQUEST_PASSWORD_RESET_FAILURE,
  payload: error
});

export const validatePasswordToken = (token) => ({
  type: VALIDATE_PASSWORD_TOKEN,
  payload: token
});

export const validatePasswordTokenSuccess = (data) => ({
  type: VALIDATE_PASSWORD_TOKEN_SUCCESS,
  payload: data
});

export const validatePasswordTokenFailure = (error) => ({
  type: VALIDATE_PASSWORD_TOKEN_FAILURE,
  payload: error
});

export const resetPassword = (passwordData, navigate) => ({
  type: RESET_PASSWORD,
  payload: { passwordData, navigate }
});

export const resetPasswordSuccess = () => ({
  type: RESET_PASSWORD_SUCCESS
});

export const resetPasswordFailure = (error) => ({
  type: RESET_PASSWORD_FAILURE,
  payload: error
});

export const registerUserRequest = (userData, navigate) => ({
  type: REGISTER_USER_REQUEST,
  payload: { userData, navigate }
});

export const registerUserSuccess = () => ({
  type: REGISTER_USER_SUCCESS,
});

export const registerUserFailure = (error) => ({
  type: REGISTER_USER_FAILURE,
  payload: error,
});

export const activateAccountRequest = (token, navigate) => ({
  type: ACTIVATE_ACCOUNT_REQUEST,
  payload: { token, navigate }
});

export const activateAccountSuccess = () => ({
  type: ACTIVATE_ACCOUNT_SUCCESS,
});

export const activateAccountFailure = (error) => ({
  type: ACTIVATE_ACCOUNT_FAILURE,
  payload: error,
});

export const verifyUserRequest = (id) => ({
  type: VERIFY_USER_REQUEST,
  payload: id
});

export const verifyUserSuccess = () => ({
  type: VERIFY_USER_SUCCESS
});

export const verifyUserFailure = (error) => ({
  type: VERIFY_USER_FAILURE,
  payload: error
});

export const activateUserRequest = (id) => ({
  type: ACTIVATE_USER_REQUEST,
  payload: id
});

export const activateUserSuccess = () => ({
  type: ACTIVATE_USER_SUCCESS
});

export const activateUserFailure = (error) => ({
  type: ACTIVATE_USER_FAILURE,
  payload: error
});

export const banUserRequest = (user, navigate) => ({
  type: BAN_USER_REQUEST,
  payload: {user, navigate}
});

export const banUserSuccess = () => ({
  type: BAN_USER_SUCCESS
});

export const banUserFailure = (error) => ({
  type: BAN_USER_FAILURE,
  payload: error
});

export const resendActivationEmailRequest = (email) => ({
  type: RESEND_ACTIVATION_EMAIL_REQUEST,
  payload: email
});

export const resendActivationEmailSuccess = () => ({
  type: RESEND_ACTIVATION_EMAIL_SUCCESS
});

export const resendActivationEmailFailure = (error) => ({
  type: RESEND_ACTIVATION_EMAIL_FAILURE,
  payload: error
});

export const sendEmailAdminRequest = (values) => ({
  type: SEND_EMAIL_ADMIN_REQUEST,
  payload: values
});

export const sendEmailAdminSuccess = () => ({
  type: SEND_EMAIL_ADMIN_SUCCESS
});

export const sendEmailAdminFailure = (error) => ({
  type: SEND_EMAIL_ADMIN_FAILURE,
  payload: error
});

export const updatePrefRequest = (userId, prefs) => ({
  type: UPDATE_PREF_REQUEST,
  payload: { userId, prefs }
});

export const updatePrefSuccess = (prefs) => ({
  type: UPDATE_PREF_SUCCESS,
  payload: { prefs }
});

export const updatePrefFailure = (error) => ({
  type: UPDATE_PREF_FAILURE,
  payload: error
});

export const clearUserErrors = () => ({
  type: CLEAR_USER_ERRORS,
});

export const clearUserSuccess = () => ({
  type: CLEAR_USER_SUCCESS,
});
